export default "__VITE_ASSET__Bvw9kqAk__"